import { APIClient } from "../helpers/api_helper";

const api = new APIClient();
const RESOURCE = "/public/email/unsubscribe";

export interface PublicUnsubscribeData {
  client_name: string;
  tenant_name: string | null;
  already_opted_out: boolean;
  message: string;
}

export const getPublicEmailUnsubscribe = async (
  token: string
): Promise<{ success: boolean; data: PublicUnsubscribeData; message?: string }> =>
  api.get(RESOURCE, { t: token });

export const confirmPublicEmailUnsubscribe = async (
  token: string
): Promise<{ success: boolean; data: PublicUnsubscribeData; message?: string }> =>
  api.create(RESOURCE, { t: token });
